// The living tile at rest, as the logo holds it: the face low right, tilted 12°.
export const TILE =
  'M100 0C186 0 200 14 200 100C200 186 186 200 100 200C14 200 0 186 0 100C0 14 14 0 100 0Z';

/**
 * Where the face sits on the tile; the landing's hand-off, the link preview and the Meetmy mark
 * (`BrandMark`, the tile in ink) draw it alike.
 */
export const FACE_TRANSFORM =
  'translate(29 32) translate(100 100) rotate(12) scale(0.8) translate(-100 -100)';

/** The face itself, in the tile's 200 units: two square eyes over a smile. */
export const EYES = [
  { x: 56, y: 64 },
  { x: 120, y: 64 },
] as const;
export const EYE_SIZE = 24;
export const SMILE = 'M66 114Q100 142 134 114';

/**
 * The teammates in the hand-off, each in its own colour (the theme's `--mm-prod`, `--mm-team`,
 * `--sf-accent`, `--mm-book`, `--sf-accent-deep`). `role` is the job a teammate signs its lines
 * with in the onboarding thread, a real sales team's titles.
 */
export const MATES = [
  { color: '#6D4DF0', role: 'Analyst' },
  { color: '#0D6B60', role: 'Content writer' },
  { color: '#F07A2A', role: 'Community manager' },
  { color: '#2A7BE4', role: 'Appointment setter' },
  // Not "Closer": the creator recommends the pack on the call; this teammate books and bills every session.
  { color: '#D63B6E', role: 'Sales assistant' },
] as const;

/** A teammate by its place in `MATES`; the onboarding thread names its speaker this way. */
export type Mate = 0 | 1 | 2 | 3 | 4;

/**
 * The team's hand-off, turn by turn: the default link preview draws it held on its last turn,
 * so the last line is the one a shared link shows: the sessions after the intro.
 */
export const HAND_OFF = [
  { mate: 0, status: 'Finding who wants to learn' },
  { mate: 2, status: 'Answering them in your voice' },
  { mate: 1, status: 'Sending each one a quiz' },
  { mate: 3, status: 'Booking the paid intro call' },
  { mate: 4, status: 'Booking the next sessions' },
] as const satisfies readonly { mate: Mate; status: string }[];

/** The teammate who signs the automated emails in the activity feed. */
export const SALES_ASSISTANT: Mate = 4;
